var React = require('react');

function AboutUsIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Icon"},[React.createElement("path",{"d":"m5.375 13.272 12.458-9.689 12.457 9.689V28.5a2.769 2.769 0 0 1-2.768 2.769H8.143A2.769 2.769 0 0 1 5.375 28.5z","transform":"translate(-1.154 -.815)","style":{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2px"},"key":0}),React.createElement("path",{"data-name":"Path","d":"M16.125 35.342V21.5h8.305v13.842","transform":"translate(-3.599 -4.89)","style":{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2px"},"key":1})]));
}

AboutUsIcon.defaultProps = {"width":"33","height":"33","viewBox":"0 0 33 33"};

module.exports = AboutUsIcon;

AboutUsIcon.default = AboutUsIcon;
